
const schema = (formData = {}) => {
  const showStats = !!formData.useStatistics;

  const fieldsets = [
    {
      id: 'default',
      title: 'Default',
      fields: ['alignment', 'columns', 'useStatistics'],
    },
    {
      id: 'mobile',
      title: 'Mobile carousel',
      fields: ['mobileCarousel', 'mobileCarouselAutoplay', 'mobileCarouselDots'],
    },
  ];

  if (showStats) {
    fieldsets.push({
      id: 'statistics',
      title: 'Statistics',
      fields: ['statsFormatK', 'statAnimationMs', 'statistics'],
    });
  } else {
    fieldsets.push({
      id: 'cards',
      title: 'Cards',
      fields: ['items'],
    });
  }

  return {
    title: 'Multi Card Block',
    fieldsets,
    properties: {
      alignment: {
        title: 'Content alignment',
        choices: [
          ['left', 'Left'],
          ['center', 'Center'],
          ['right', 'Right'],
        ],
        type: 'string',
        default: 'left',
      },
      columns: {
        title: 'Number of columns (desktop)',
        type: 'number',
        minimum: 1,
        maximum: 6,
        default: 3,
      },
      useStatistics: {
        title: 'Use statistics instead of cards',
        type: 'boolean',
        default: false,
        description: 'If enabled, cards are hidden (not deleted) and a statistics list is shown instead.',
      },
      statsFormatK: {
        title: 'Compact thousands into k for all stats',
        type: 'boolean',
        default: false,
        description: 'When enabled and value ≥ 1000, animate in 1000-steps and display as “xk”.',
      },
      statAnimationMs: {
        title: 'Animation duration (ms) for all stats',
        type: 'number',
        default: 6000,
        description: 'How long the number animation should take, in milliseconds (e.g., 6000 = 6 seconds).',
        minimum: 200,
        maximum: 60000,
      },
      mobileCarousel: {
        title: 'Use carousel on mobile',
        type: 'boolean',
        default: false,
        description: 'On ≤ 768px, items/statistics become a swipeable carousel.',
      },
      mobileCarouselAutoplay: {
        title: 'Autoplay (mobile)',
        type: 'boolean',
        default: true,
      },
      mobileCarouselDots: {
        title: 'Show dots (mobile)',
        type: 'boolean',
        default: true,
      },
      items: {
        title: 'Cards',
        widget: showStats ? 'hidden' : 'object_list',
        default: [],
        schema: {
          title: 'Card',
          fieldsets: [
            {
              id: 'default',
              title: 'Default',
              fields: ['title', 'description', 'linkText', 'url', 'anchor', 'image'],
            },
          ],
          properties: {
            title: { title: 'Title', type: 'string' },
            description: { title: 'Introduction', type: 'string' },
            linkText: { title: 'Link text', type: 'string' },
            url: {
              title: 'Link URL',
              widget: 'object_browser',
              mode: 'link',
              allowExternals: true,
            },
            anchor: {
              title: 'Anchor (optional)',
              type: 'string',
              description: 'Appends to link. If no link is set, this becomes the target.',
            },
            image: {
              title: 'Background image',
              widget: 'image',
            },
          },
          required: [],
        },
      },
      statistics: {
        title: 'Statistics',
        widget: showStats ? 'object_list' : 'hidden',
        default: [],
        schema: {
          title: 'Statistic',
          fieldsets: [
            {
              id: 'default',
              title: 'Default',
              fields: ['label', 'value', 'suffix', 'extraInfo', 'url', 'anchor'],
            },
          ],
          properties: {
            label: { title: 'Label', type: 'string' },
            value: {
              title: 'Value (number)',
              type: 'number',
              description: 'Counts up from 0 to this value. Must be a number.',
            },
            suffix: { title: 'Suffix (e.g. % or +)', type: 'string' },
            extraInfo: { title: 'Extra info', type: 'string' },
            url: {
              title: 'Link URL (optional)',
              widget: 'object_browser',
              mode: 'link',
              allowExternals: true,
            },
            anchor: {
              title: 'Anchor (optional)',
              type: 'string',
              description: 'Appends to link. If no link is set, this becomes the target.',
            },
          },
          required: ['value'],
        },
      },
    },
    required: [],
  };
};

export default schema;
